import { MijnRoute } from '../../mijn-navigatie.model';

export const INSURANCES_DETAILS: MijnRoute = {
    path: 'details/:id',
    navigationEvent: 'toVerzekerenDetails',
    regex: /^\/verzekeren-beheren\/details\/[^/]+$/,
    webcomponent: 'mijn-verzekeren-beheer-webcomponent',
    internalPath: '/details/:id'
};
